module.exports = __webpack_public_path__ + "static/media/(DH)_MG_5679_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_Moda_Feminina_Infantil.9c38a175.jpg";